import { getMonthFromDate } from "../../../extensions/date";
import type { RajasthanCollective } from "../../../models/rajasthan";
import { getGridcoCollectiveData } from "../../../Rest_api/RestApi";

export interface GridcoProcurementCompareItem {
  date: string;
  time_block: number;
  time_slot: number;
  exchange: string;
  product: string;
  price_kwh: number;
  entity?: string;
  toEntity?: string;
  type: string;
  value_mw: number;
  value_mwh: number;
  cost: number;
  month: string;
  exchange__name: string;
  product__name: string;
  wt_mcp_rs_kwh: number;
  [key: string]: any;
}

export interface GridcoProcurementData {
  collective: RajasthanCollective[];
  compare: GridcoProcurementCompareItem[];
}

export async function getGridcoProcurementData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<{
  compareData: GridcoProcurementCompareItem[];
  data: GridcoProcurementData;
}> {
  const collectiveData = await getGridcoCollectiveData({
    startDate,
    endDate,
  });

  const processedCollectiveData: GridcoProcurementCompareItem[] =
    collectiveData.map((item) => {
      const isBuy = item.value_mw > 0;
      return {
        ...item,
        type: isBuy ? "Collective Buy" : "Collective Sell",
        time_block: item.time_slot,
        exchange: item.exchange__name,
        product: item.product__name,
        price_kwh: item.wt_mcp_rs_kwh,
        entity: item.exchange__name + " " + item.product__name,
        value_mwh: Math.abs(item.value_mw) / 4,
        value_mw: Math.abs(item.value_mw),
        cost: Math.abs(item.cost),
        month: getMonthFromDate(item.date),
      };
    });

  return {
    compareData: processedCollectiveData,
    data: {
      collective: collectiveData,
      compare: processedCollectiveData,
    },
  };
}
